export default (source, begin, end) => (
  source.split('').map((letter, index) => {
    if (index >= begin && index <= end) {
      return '*';
    }

    return letter;
  }).join('')
);
